import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Box, Switch } from '@mui/material'
import { TableUrlPagination } from '../../../../ui'
import { COLLABORATORS_TABLE_ACTIONS, COLLABORATORS_TABLE_COLUMNS } from '../../constants'
import { collaboratorsDataPreparation } from '../../logics'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const CollaboratorsTable = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const collaboratorsLoader = useSelector((state) => state.loader.collaborators)
  const data = collaboratorsLoader?.data?.registros || []
  const totalEntries = collaboratorsLoader?.data?.total_registros
  const search = collaboratorsLoader?.config?.params
  const loading = collaboratorsLoader?.loading
  const combos = useSelector((state) => state.combos)

  const formattedColumns = useMemo(
    () =>
      [...COLLABORATORS_TABLE_COLUMNS, ...COLLABORATORS_TABLE_ACTIONS].map((column) => {
        const baseColumn = {
          accessorKey: column.field,
          header: formatMessage({
            id: `pages.collaborators.table.columns.${column.field}.title`,
          }),
        }

        if (column.field === 'active') {
          return {
            ...baseColumn,
            header: formatMessage({ id: `global.${column.field}` }),
            Cell: ({ cell }) => <Switch checked={cell.getValue()} disabled />,
            muiTableBodyCellProps: { align: 'center' },
          }
        }

        if (column.isAction) {
          return {
            ...baseColumn,
            header: formatMessage({ id: 'global.actions' }),
            Cell: (props) => <span>Acciones aquí</span>, // Reemplazar con el componente de acciones real
            muiTableBodyCellProps: { align: 'center' },
          }
        }

        if (column.comboId && combos[column.comboId]?.data) {
          const lookup = getLookup(combos[column.comboId].data)
          return {
            ...baseColumn,
            Cell: ({ cell }) => {
              const value = cell.getValue()
              return <span>{lookup[value] ?? value ?? '--'}</span>
            },
          }
        }

        return {
          ...baseColumn,
          Cell: ({ cell }) => {
            const value = cell.getValue()
            return <Box sx={{ padding: '0 16px' }}>{value ?? '--'}</Box>
          },
        }
      }),
    [combos, formatMessage]
  )

  const processedData = useMemo(() => collaboratorsDataPreparation(data, { intl }), [data, intl])

  const tableOptions = useMemo(
    () => ({
      toolbar: false,
      selection: false,
      tableLayout: 'fixed',
      draggable: false,
    }),
    []
  )

  return (
    <TableUrlPagination
      columns={formattedColumns}
      options={tableOptions}
      totalEntries={totalEntries}
      search={search}
      data={processedData}
      isLoading={loading}
      onRowClick={null}
    />
  )
}
